import { Component, OnInit } from '@angular/core';
import { ToursService } from '../../../services/tours.service';
import { DcService } from '../../../services/dc.service';
import { ModalService } from '../../../services/modal.service';
import { AllMessengersService } from '../../../pages/page-start/all-messengers.service';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import { ShepherdService } from 'angular-shepherd';
import { SenderService } from '../../../services/sender.service';
import { InterfaceService } from '../../../services/interface.service';
import { defaultStepOptions } from '../../../tour/data';
import Step from 'shepherd.js/src/types/step';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-lead-task-shepherd',
  templateUrl: './lead-task-shepherd.component.html',
  styleUrls: ['./lead-task-shepherd.component.scss']
})
export class LeadTaskShepherdComponent implements OnInit {

  constructor(
    private toursService: ToursService,
    private dcService: DcService,
    public modalService: ModalService,
    public allMessengersService: AllMessengersService,
    public notifierWrapService: NotifierWrapService,
    private shepherdService: ShepherdService,
    public senderService: SenderService,
    public interfaceService: InterfaceService,
  ) {
  }

  next(): void {
    if (this.shepherdService.isActive) {
      this.shepherdService.next();
    }
  }

  ngOnInit(): void {
    this.toursService.startLeadTaskTour$
      .pipe(debounceTime(100))
      .subscribe((timeout) => {
        if (this.toursService.tourLeadTaskNotShow) {
          return;
        }
        this.closeModal();
        this.shepherdService.confirmCancelMessage = 'Инструкция по добавлению задания на сканирование.';
        this.shepherdService.defaultStepOptions = defaultStepOptions;
        this.shepherdService.modal = true;
        this.shepherdService.confirmCancel = false;
        this.shepherdService.addSteps([
          this.introStep,
          this.nameFieldStep,
          /*this.textsFieldStep,
          this.scopeFieldStep,*/
          // this.allScanFieldStep,
          this.chatsFieldStep,
          this.autoScanStep,
          this.typeFieldStep
        ]);

        setTimeout(() => {
          this.shepherdService.start();
        }, timeout);
      });
  }

  closeModal() {
    if (this.modalService.bsModalRef) {
      this.modalService.bsModalRef.hide();
    }
  }

  get buttons(): Step.StepOptionsButton[] {
    const array = [
      {
        action: () => {
          this.toursService.tourLeadTaskNotShow = true;
          return true;
        },
        text: 'Я умею',
        classes: 'btn btn-link',
      },
      {
        action: () => {
          return this.next();
        },
        text: 'Научи меня',
        classes: 'btn btn-primary',
      }
    ];
    return array;
  }

  get introStep(): Step.StepOptions {
    return {
      id: 'variations-start',
      attachTo: {
        element: '',
        on: 'bottom'
      },
      buttons: this.buttons,
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Ваше первое задание на сканирование чатов.',
      text: ['Мы рекомендуем пройти быстрый гид по форме добавления заданий поиска лидов.'],
    };
  }

  get typeFieldStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'lead-task-start-button',
      attachTo: {
        element: '#add-task-type',
        on: 'bottom'
      },
      buttons: [
        {
          action: () => {
            this.toursService.tourLeadTaskNotShow = true;
            this.shepherdService.complete();
            return true;
          },
          classes: 'btn btn-link',
          text: 'Завершить'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Спасибо, теперь вы готовы!',
      text: ['Сейчас мы рассмотрели создание своего задания с нуля, но у нас есть и заготовленные задания, которые, возможно подойдут к Вашей тематике, для этого Вы можете переключиться и подписаться тут.'],
    };
  }

  get nameFieldStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'lead-task-name-field',
      attachTo: {
        element: '#add-task-name',
        on: 'bottom'
      },
      buttons: [
        {
          action() {
            return this.next();
          },
          classes: 'btn btn-link',
          text: 'Далее'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Придумайте название',
      text: ['Название задания нужно только для удобства распознавания в списке заданий позже, можно вписать что-то характеризующее это задание.'],
    };
  }

  get scopeFieldStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'lead-task-scope-field',
      attachTo: {
        element: '#lead-task-scope',
        on: 'bottom'
      },
      buttons: [
        {
          action() {
            return this.next();
          },
          classes: 'btn btn-link',
          text: 'Далее'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Порог схожести сообщений с примерами',
      text: ['Нейросеть сравнивает сообщения в чатах с приведенными ниже примерами и вычисляет процент их смысловой схожести. При пороге около 50% возможно получение нерелевантных лидов, в то время как порог около 60% обеспечивает почти точное совпадение. Однако слишком высокий порог может привести к пропуску потенциально важных лидов. <b>Рекомендуем начать с порога в 52%</b>.'],
    };
  }

  // title: 'Ограничение по чатам',
  // text: ['Если оставить включенным, для задания будут
  // сканироваться все чаты в нашем сервисе, это около 4 000
  // отобранных чатов. Иначе только указанные в задании.'],

  get chatsFieldStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'lead-task-chats-field',
      attachTo: {
        element: '#lead-task-chats',
        on: 'bottom'
      },
      buttons: [
        {
          action() {
            return this.next();
          },
          classes: 'btn btn-link',
          text: 'Далее'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Список ваших чатов',
      text: [
        'Вы можете указать чаты (дополнительно к существующим в системе), в которых необходимо искать сообщения по этому заданию, это должны быть открытые группы или по пригласительной ссылке, например:' +
        '<ul>' +
        '<li>https://t.me/+26QnjKykLJIxZjJi</li>' +
        '<li>https://t.me/teleseller_chat</li>' +
        '<li>@teleseller_chat</li>' +
        '</ul>' +
        '<small class="text-muted shepherd-text-footer">Каждый чат должен быть указан в отдельное поле, поддерживается массовое добавление, если скопированный список имеет перенос строки после каждого чата, можно просто сделать вставку (ctrl + v)</small>'
      ],
    };
  }

  get textsFieldStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'lead-task-chats-field',
      attachTo: {
        element: '#lead-task-texts',
        on: 'bottom'
      },
      buttons: [
        {
          action() {
            return this.next();
          },
          classes: 'btn btn-link',
          text: 'Далее'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Примеры объявлений/сообщений',
      text: [
        'Это самое важное в задании, необходимо качественно добавить варианты написания сообщений которые вы хотите отфильтровать и получить как лид.</br>' +
        'Важно понимать, нейросеть сравнивает предложения по смыслу, тут нужно указываь полноценные предложения, но краткие и обощенные, как потенциально напишут люди в сканируемых чатах. Например:</br>' +
        '<ul>' +
        '<li>Ищу репетитора по !математике</li>' +
        '<li>Нужен тренер по !йоге </li>' +
        '<li>Ищу специалиста по ремонту !компьютеров</li>' +
        '<li>Мне нужен !гид для путешествия</li>' +
        '<li>Ищу специалиста по созданию !сайтов</li>' +
        '<li>Мне нужно создать !интернет-магазин, ищу разработчика</li>' +
        '<li>Предлагаю услуги по созданию !интернет-магазинов</li>' +
        '</ul>' +
        '<small class="text-muted shepherd-text-footer">Для обозначения ключевого слова, нужно указывать знак восклицания перед ним.</small>'
      ],
    };
  }


  get autoScanStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'lead-task-autoscan-field',
      attachTo: {
        element: '#lead-task-autoscan',
        on: 'bottom'
      },
      buttons: [
        {
          action() {
            return this.next();
          },
          classes: 'btn btn-link',
          text: 'Далее'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Автоматический ответ',
      text: [
        'Эта функция еще на стадии тестирования, сейчас лучше не использовать, сначала нужно отточить задание, что бы вы получали качественные, подходящие Вам лиды.<br>' +
        'Когда задание будет работать идеально или почти идеально, можно попробовать этот функционал.'
      ],
    };
  }
}
